import {
  TECHNOLOGIES,
  TECHNOLOGY_CONFIGURATIONS,
  TECHNOLOGY_ENDPOINT_PREFIXES,
  TECHNOLOGY_FIELD_USAGES,
  TECHNOLOGY_IMPORTS,
  TECHNOLOGY_INSTANCES,
  TECHNOLOGY_LIBRARY_IMPORTS,
  TECHNOLOGY_USAGES,
  TECHNOLOGY_VARIABLES,
} from '@/core/config'

import type { CodeState } from './types'

export const defaultValues: CodeState = {
  selectedTechnology: undefined,
  suggestedTechnologies: [],
  technologies: TECHNOLOGIES,
  technologySetupCommands: {},
  technologyConfigurations: TECHNOLOGY_CONFIGURATIONS,
  technologyImports: TECHNOLOGY_IMPORTS,
  technologyLibraryImports: TECHNOLOGY_LIBRARY_IMPORTS,
  technologyInstances: TECHNOLOGY_INSTANCES,
  technologyUsages: TECHNOLOGY_USAGES,
  technologyFieldUsages: TECHNOLOGY_FIELD_USAGES,
  technologyVariables: TECHNOLOGY_VARIABLES,
  technologyEndpointPrefixes: TECHNOLOGY_ENDPOINT_PREFIXES,
}
